import PrimaryModal from "../UI/Modal/PrimaryModal";

const FunctionModal = ({ functions, hideModal }) => {
    return (
        <PrimaryModal title="Product Functions" hideModal={hideModal}>
            <div className="p-6 max-h-96 overflow-y-auto">
                <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
                    {functions && functions.length > 0 ? (
                        functions.map((func) => (
                            <div
                                key={func._id}
                                className="border border-gray-300 rounded-lg p-4 shadow-sm bg-white"
                            >
                                <h3 className="text-lg font-semibold text-gray-800">{func.title}</h3>
                                <p className="text-sm text-gray-600 mt-2">{func.description}</p>
                                <div className="mt-4">
                                    <span
                                        className={`inline-block px-3 py-1 text-xs font-semibold rounded-full ${func.available ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
                                            }`}
                                    >
                                        {func.available ? 'Available' : 'Unavailable'}
                                    </span>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p>No functions available</p>
                    )}
                </div>
            </div>
        </PrimaryModal>
    );
};

export default FunctionModal;